export const GET_TIMELINE = 'GET_TIMELINE';
export const GET_TIMELINE_SUCCESS = 'GET_TIMELINE_SUCCESS';
export const GET_TIMELINE_ERROR = 'GET_TIMELINE_ERROR';